import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const DirectoryToolbar = ({ filters, setFilters, wilayas }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v === "all" ? "" : v }));
  return (
    <>
      <div className="relative w-full sm:w-72">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
        <Input className="pl-9 bg-white" placeholder="Nom, adresse, téléphone…" value={filters.q} onChange={(e) => set("q")(e.target.value)} data-testid="directory-search" />
      </div>
      <Select value={filters.wilaya || "all"} onValueChange={set("wilaya")}>
        <SelectTrigger className="w-48 bg-white" data-testid="directory-wilaya-filter"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Toutes les wilayas</SelectItem>
          {wilayas.map((w) => <SelectItem key={w.code} value={w.code}>{w.code} — {w.name} ({w.count})</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={filters.verified || "all"} onValueChange={set("verified")}>
        <SelectTrigger className="w-40 bg-white" data-testid="directory-verified-filter"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Toutes les fiches</SelectItem>
          <SelectItem value="true">Vérifiées</SelectItem>
          <SelectItem value="false">Non vérifiées</SelectItem>
        </SelectContent>
      </Select>
    </>
  );
};
